import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { BaseComponent } from 'src/app/shared/components/base.component'

@Component({
  selector: 'app-refresh-app-dialog',
  templateUrl: './refresh-app-dialog.component.html',
  styleUrls: ['./refresh-app-dialog.component.scss'],
})
export class RefreshAppDialogComponent extends BaseComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<RefreshAppDialogComponent>) {
    super()
  }

  ngOnInit(): void {}

  refresh() {
    this.dialogRef.close()
  }
}
